import NetworkTitle from './NetworkTitle.jsx';
import './NetworkTitle.less';

export default NetworkTitle;
